import React, { FC, useEffect, useRef, useState } from 'react';
import TitleContentSummary from 'src/components/molecules/contentLayout/TitleContentSummary';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';
import TaxationDetail from 'src/components/molecules/table/CompanyDetail/taxationDetail';
import TaxDetail from '../taxDetail';
import NoneTaxationDetail from '../noneTaxationDetail';
import DeductionDetail from '../deductionDetail';
import PensionDetail from '../pensionDetail';
import InsuranceDetail from '../insuranceDetail';
import NoResult from 'src/components/molecules/table/NoResult';

import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import './style.scss';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ data, type = '' }) => {
  const foldClickEvent = (id: string, status: string) => {};
  const ocrEvt = () => {};
  const labelStyle = { width: '380px', color: '#777', fontSize: '13px' };

  return (
    <div className="_company_before_detail_set">
      <div className="_content_div">
        <section className="_item_div _taxation_div">
          <div className="_main_content_div">
            <TitleContentSummary
              id="taxation"
              label="과세대상 급여 항목"
              desc=<div>
                과세대상 급여 내역은 연말정산 세액 계산의 기준이 되므로 지급 금액 및 항목을 반드시
                확인해 주시기 바랍니다.
              </div>
              foldBtnText={['상세 보기', '요약 보기']}
              content={<TaxationDetail type={type} data={data} />}
              foldBtn={true}
              foldBtnClickEvent={foldClickEvent}
              contentView={true}
              styleDef={{ maxHeight: '30px' }}
            />
          </div>
        </section>
        <section className="_item_div _taxation_div">
          <div className="_main_content_div">
            <TitleContentSummary
              id="taxation"
              label="세금"
              desc=<div>
                세금 항목은 해당 연도 급여에서 원천징수된 세액 내역입니다. <br />
                연말정산 시 공제 및 감면 사항이 반영되어 최종 결정세액과 비교한 후 환급 또는 추가
                납부 금액이 산정됩니다.
              </div>
              foldBtnText={['상세 보기', '요약 보기']}
              content={<TaxDetail type={type} data={data} />}
              foldBtn={true}
              foldBtnClickEvent={foldClickEvent}
              contentView={true}
              styleDef={{ maxHeight: '30px' }}
            />
          </div>
        </section>
        <section className="_item_div _taxation_div">
          <div className="_main_content_div">
            <TitleContentSummary
              id="taxation"
              label="연금"
              desc=<div>
                연금 항목은 해당 연도에 납부한 국민연금 등 법정 연금보험료 내역입니다. <br />
                납부 금액은 연말정산 시 소득공제 대상에 반영되며, 실제 납부 내역과 일치하는지
                확인하시기 바랍니다.
              </div>
              content={<PensionDetail type={type} data={data} />}
              foldBtn={true}
              foldBtnText={['상세 보기', '요약 보기']}
              foldBtnClickEvent={foldClickEvent}
              contentView={true}
              styleDef={{ maxHeight: '30px' }}
            />
          </div>
        </section>
        <section className="_item_div _taxation_div">
          <div className="_main_content_div">
            <TitleContentSummary
              id="taxation"
              label="보험"
              desc=<div>
                보험 항목은 해당 연도에 납부한 건강보험료, 장기요양보험료, 고용보험료 등 사회보험료
                내역입니다. <br />
                납부 금액은 관련 법령에 따라 연말정산에 반영되므로 실제 납부 내역과 일치하는지
                확인하시기 바랍니다.
              </div>
              content={<InsuranceDetail type={type} data={data} />}
              foldBtn={true}
              foldBtnText={['상세 보기', '요약 보기']}
              foldBtnClickEvent={foldClickEvent}
              contentView={true}
              styleDef={{ maxHeight: '30px' }}
            />
          </div>
        </section>
        <section className="_item_div _non_taxation_div">
          <div className="_main_content_div">
            <TitleContentSummary
              id="nontaxation"
              label="비과세대상 급여 항목"
              desc=<div>
                비과세대상 급여 항목은 소득세법상 비과세 요건을 충족하여 과세 대상에서 제외되는
                급여입니다. <br />
                해당 내역은 연말정산 시 관련 법령에 따라 반영되므로 지급 내역을 확인하시기 바랍니다.
              </div>
              content={<NoneTaxationDetail type={type} data={data} />}
              foldBtn={true}
              foldBtnText={['상세 보기', '요약 보기']}
              foldBtnClickEvent={foldClickEvent}
              contentView={true}
              styleDef={{ maxHeight: '30px' }}
            />
          </div>
        </section>

        <section className="_item_div _deduction_div">
          <div className="_main_content_div">
            <TitleContentSummary
              id="deduction"
              label="공제대상 급여 항목"
              desc=<div>
                공제대상 급여 항목은 연말정산 시 공제 계산의 기준이 되는 급여 내역입니다. <br />
                지급 금액과 항목을 확인하시고, 실제 급여 내역과 차이가 있는 경우 연말정산 제출 전
                인사·급여 담당자에게 문의하시기 바랍니다.
              </div>
              content={<DeductionDetail type={type} data={data} />}
              foldBtn={true}
              foldBtnText={['상세 보기', '요약 보기']}
              foldBtnClickEvent={foldClickEvent}
              contentView={true}
              styleDef={{ maxHeight: '30px' }}
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default GridList;
